import { ICON_COLOR } from './Icon.colors';
import { ICON_TYPE } from './Icon.types';
import { account } from './icons/account';
import { arrowDown } from './icons/arrowDown';
import { arrowLeft } from './icons/arrowLeft';
import { arrowRight } from './icons/arrowRight';
import { arrowUp } from './icons/arrowUp';
import { checkMark } from './icons/checkMark';
import { clock } from './icons/clock';
import { close } from './icons/close';
import { envelopeInMotion } from './icons/envelopeInMotion';
import { envelopeStatic } from './icons/envelopeStatic';
import { facebook } from './icons/facebook';
import { hamburger } from './icons/hamburger';
import { instagram } from './icons/instagram';
import { lock } from './icons/lock';
import { magnifyingGlass } from './icons/magnifyingGlass';
import { pinterest } from './icons/pinterest';
import { plus } from './icons/plus';
import { snapchat } from './icons/snapchat';
import { star } from './icons/star';
import { tickets } from './icons/tickets';
import { tiktok } from './icons/tiktok';
import { tooltip } from './icons/tooltip';
import { twitter } from './icons/twitter';
import { youtube } from './icons/youtube';
import {
    IIcon,
    IIconAsset,
} from './IIconAssetMap';

export const ICON_ASSET_MAP: IIconAsset = {
    [ICON_TYPE.OZ_ACCOUNT]: account,
    [ICON_TYPE.OZ_ARROW_DOWN]: arrowDown,
    [ICON_TYPE.OZ_ARROW_LEFT]: arrowLeft,
    [ICON_TYPE.OZ_ARROW_RIGHT]: arrowRight,
    [ICON_TYPE.OZ_ARROW_UP]: arrowUp,
    [ICON_TYPE.OZ_CHECK_MARK]: checkMark,
    [ICON_TYPE.OZ_CLOCK]: clock,
    [ICON_TYPE.OZ_CLOSE]: close,
    [ICON_TYPE.OZ_ENVELOPE_IN_MOTION]: envelopeInMotion,
    [ICON_TYPE.OZ_ENVELOPE_STATIC]: envelopeStatic,
    [ICON_TYPE.OZ_FACEBOOK]: facebook,
    [ICON_TYPE.OZ_HAMBURGER]: hamburger,
    [ICON_TYPE.OZ_INSTAGRAM]: instagram,
    [ICON_TYPE.OZ_LOCK]: lock,
    [ICON_TYPE.OZ_MAGNIFYING_GLASS]: magnifyingGlass,
    [ICON_TYPE.OZ_PINTEREST]: pinterest,
    [ICON_TYPE.OZ_PLUS]: plus,
    [ICON_TYPE.OZ_SNAPCHAT]: snapchat,
    [ICON_TYPE.OZ_STAR]: star,
    [ICON_TYPE.OZ_TICKETS]: tickets,
    [ICON_TYPE.OZ_TIKTOK]: tiktok,
    [ICON_TYPE.OZ_TOOLTIP]: tooltip,
    [ICON_TYPE.OZ_TWITTER]: twitter,
    [ICON_TYPE.OZ_YOUTUBE]: youtube,
};

export function getIconAsset (type: ICON_TYPE, color?: ICON_COLOR): string {
    const iconTypeMap: IIcon = ICON_ASSET_MAP[type];

    if (iconTypeMap && color && iconTypeMap[color]) {
        return iconTypeMap[color] || '';
    }

    return (iconTypeMap && iconTypeMap.DEFAULT) || '';
}
